module.exports = __webpack_public_path__ + "cc9f9f3c2c6e632e0993b8a4bd38be34.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/category-img.png
// module id = 176
// module chunks = 0